<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>选择月份：</label>
                <el-date-picker v-model="month1" type="month" value-format="yyyyMM" 
                    placeholder="选择月份"
                    style="width: 120px" @change="monthChange">
                </el-date-picker>
            </div>
            <div class="searchGroup" v-if="month1>202403">
                <label>选择表：</label>
                <el-select v-model="month2" clearable placeholder="请选择" @change="bChange">
                    <el-option label="0" value="0"> </el-option>
                    <el-option label="1" value="1"> </el-option>
                    <el-option label="2" value="2"> </el-option>
                    <el-option label="3" value="3"> </el-option>
                    <el-option label="4" value="4"> </el-option>
                    <el-option label="5" value="5"> </el-option>
                    <el-option label="6" value="6"> </el-option>
                    <el-option label="7" value="7"> </el-option>
                    <el-option label="8" value="8"> </el-option>
                    <el-option label="9" value="9"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>报告类型：</label>
                <el-select v-model="search_Obj.f_report_type" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('report_type')" :key="'report_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>邮箱：</label>
                <el-input v-model="search_Obj.f_email" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>车型：</label>
                <el-input v-model="search_Obj.f_car_type" clearable @keyup.enter.native="doSearch" style="width: 140px"></el-input>
            </div>
            <div class="searchGroup">
                <label>是否已读：</label>
                <el-select v-model="search_Obj.f_is_read" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('is_read')" :key="'is_read'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>已读方式：</label>
                <el-select v-model="search_Obj.f_read_type" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('read_type')" :key="'read_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>CarId：</label>
                <el-input v-model="search_Obj.f_car_id" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>VehicleId：</label>
                <el-input v-model="search_Obj.f_vehicle_id" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>详细地点：</label>
                <el-input v-model="search_Obj.f_begin_address_detail" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>记录时间：</label>
                <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    @change="dateRangeSet"
                    style="width:320px">
                </el-date-picker>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column prop="report_type" label="报告类型" sortable="custom" min-width="140" fixed="left">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.report_type, "report_type") }} {{scope.row.id}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="email" label="邮箱" sortable="custom" width="180" fixed="left"></el-table-column>
                <el-table-column prop="car_type" label="车型" sortable="custom" width="100" fixed="left"></el-table-column>
                <el-table-column prop="create_time" label="记录时间" sortable="custom" width="180" fixed="left"></el-table-column>
                <el-table-column prop="show_duration" label="用时" sortable="custom" width="100" fixed="left"></el-table-column>
                <el-table-column prop="mileage" label="行驶里程" sortable="custom" width="120" fixed="left">
                    <template slot-scope="scope">
                        <span>{{ scope.row.mileage }}km</span>
                    </template>
                </el-table-column>
                <el-table-column prop="car_id" label="CarId" sortable="custom" width="170"></el-table-column>
                <el-table-column prop="vehicle_id" label="VehicleId" sortable="custom" width="170"></el-table-column>
                <el-table-column prop="is_read" label="是否已读" sortable="custom" min-width="120">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.is_read, "is_read") }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="is_read" label="已读方式" sortable="custom" min-width="120">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.read_type, "read_type") }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120" align="center" fixed="right">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看车辆报告"
            :data_month="search_Obj.data_month"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"
import {exportExport} from "@/api/carreport"

export default {
    name: 'carReportList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '车辆报告',
            menu_id: 2300,
            list_url: "/api/admin/carreport/list1",
            search_Obj: {
                f_report_type: '',
                f_email: '',
                f_car_type: '',
                f_car_id: '',
                f_vehicle_id: '',
                f_create_time_s_date: '',
                f_create_time_e_date: '',
                f_is_read: '',
                f_read_type: '',
                f_begin_address_detail: '',
                data_month: '',
            },
            month_int: 0,
            month1: '',
            month2: '0',
            del_Obj:{
                url:'/api/admin/carreport/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['is_read', 'read_type', 'report_type'],
            dateRange: '',
            dateRange1: '',
        };
    },
    methods: {
        initPageParams() {
            this.search_Obj["pageNum"] = this.current;
            this.search_Obj["pageSize"] = this.pagesize;
            if (this.sortData.prop != '') {
                this.search_Obj["sorterName"] = this.sortData.prop;
                this.search_Obj["sorterDirection"] = this.sortData.order;
            }
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            this.month1 = `${year}${month}`;
            this.monthChange(this.month1)
        },
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.search_Obj.f_create_time_s_date = val[0]
                this.search_Obj.f_create_time_e_date = val[1]
            }else{
                this.search_Obj.f_create_time_s_date = ''
                this.search_Obj.f_create_time_e_date = ''
            }
        },
        exportReport(){
            var data = {
                "month": this.search_Obj.data_month,
                "report_type": this.search_Obj.f_report_type,
                "email": this.search_Obj.f_email,
                "car_type": this.search_Obj.f_car_type,
                "is_read": this.search_Obj.f_is_read,
                "read_type": this.search_Obj.f_read_type,
                "car_id": this.search_Obj.f_car_id,
                "vehicle_id": this.search_Obj.f_vehicle_id,
                "create_time_start": this.search_Obj.f_create_time_s_date,
                "create_time_end": this.search_Obj.f_create_time_e_date
            }
            exportExport(data).then(res=>{
                if(res.code ==1){
                    setTimeout(() => {
                        window.open(res.data+"")
                    }, 500);
                }else if(res.code ==990){
                    this.$msg("无数据可导出")
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        monthChange(val){
            this.month1 = val
            this.month_int = parseFloat(this.month1)
            if(val>202403){
                this.search_Obj.data_month = val+""+this.month2
            }else{
                this.search_Obj.data_month = val
            }
            console.log(this.search_Obj.data_month)
        },
        bChange(val){
            if(this.month1>202403){
                this.search_Obj.data_month = this.month1+""+val
            }else{
                this.search_Obj.data_month = this.month1
            }
            console.log(this.search_Obj.data_month)
        }
    }
};
</script>